import Vue from 'vue'

import mixins from '@/app/mixins/mixins'
import {axiosPlugin} from '@/app/plugins/Axios'
import {authPlugin} from '@/app/plugins/Auth'
import {cookiePlugin} from '@/app/plugins/Cookie'
import { createLocalStorage } from "@/app/utils/LocalStorage";
import createCookie from '@/app/core/CookieCore';
import globals from '@/app/globals';
import config from '@/app/config';
import eventbus from '@/app/eventbus';
import validacoes from '@/app/utils/validacoes'
import vuetifyConfig from '@/app/vuetifyConfig';
import '@/assets/estilos.css';
import '@/pages/buscas';
import * as icon from '@/app/icons';


import moment from 'moment';
import dayjs from "dayjs";
import zComponents from '@/components/zComponents';
import VueTheMask from 'vue-the-mask'
import '@/app/filters';

import AppBoot from "@/pages/layout/AppBoot.vue";

// Carregar Plugins
Vue.prototype.$eventbus = eventbus;
Vue.prototype.$moment = moment;
Vue.prototype.$validacoes = validacoes;
Vue.prototype.$v = vuetifyConfig;
Vue.prototype.$storage = createLocalStorage(config);
Vue.prototype.$cookie = createCookie();
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$icon = icon;
Vue.prototype.$config = config;

Vue.use(VueTheMask)
Vue.use(config);
Vue.use(globals);
Vue.use(zComponents);
Vue.use(axiosPlugin);
Vue.use(cookiePlugin);
Vue.use(authPlugin);
Vue.mixin(mixins);

// Register Components Globally
Vue.component("AppBoot", AppBoot);

// Diretiva para exibir apenas em ambiente de desenvolvimento <div v-dev>...</div>
Vue.directive('dev', {
  inserted(el, binding) {
    if (process.env.NODE_ENV !== 'development') {
      el.parentNode.removeChild(el);
    }
  }
})